import UtilService from "../services/util.service";

export default {
  name: "toCronReadable",
  fn: value => {
    return UtilService.toCronReadable(value);
  }
};
